import React from "react";
import { useNavigate } from "react-router-dom";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { AlertTriangle } from "lucide-react";

export default function ExpiredScreen() {
  const nav = useNavigate();
  return (
    <div className="max-w-2xl mx-auto py-10 animate-fade-up">
      <Card className="p-8 text-center border-destructive/40" data-testid="expired-card">
        <div className="mx-auto h-14 w-14 rounded-full bg-destructive/10 text-destructive grid place-items-center">
          <AlertTriangle className="h-7 w-7" />
        </div>
        <h1 className="mt-6 font-heading font-bold text-3xl">Your subscription has expired</h1>
        <p className="mt-3 text-muted-foreground">Please contact admin to renew your subscription and regain access to daily data.</p>
        <div className="mt-6 flex justify-center gap-2">
          <Button onClick={() => nav("/onboarding")} data-testid="expired-request-renewal">Request new subscription</Button>
        </div>
      </Card>
    </div>
  );
}
